import { PlanType } from '@showbie-socrative/socrative-utils';

import axios from '../localAxios';
import { QuizLimitResponse } from './types';
import { quizLimitURL } from './url';

export type QuizLimit = {
  currentQuizCount: number;
  limit: number;
};

export async function getQuizLimit(userPlan: PlanType) {
  if (
    [
      PlanType.FreeLegacy,
      PlanType.Pro,
      PlanType.Organization,
      PlanType.Complete,
      PlanType.Essentials,
    ].includes(userPlan)
  ) {
    return { currentQuizCount: null, limit: Infinity };
  }
  const result = await axios.get<QuizLimitResponse>(quizLimitURL().href);
  const { currentQuizCount = null, limit = Infinity } = result.data;
  return { currentQuizCount, limit } as QuizLimit;
}
